import notify from 'devextreme/ui/notify';
import { Injectable } from '@angular/core';
import { iBisAuthService, iBisEditUserService } from '@dohu/ibis-auth';
import { iBisFileService, iBisLanguageService, iBisUIService } from '@dohu/ibis-common';
import { iBisNavigationService } from '@dohu/ibis-navigation';
import { iBisEntityService } from '@dohu/ibis-entity';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadExcelService } from '../view/routes/upload-excel/upload-excel.service';

@Injectable()
export class ProxyService {

	constructor(public auth: iBisAuthService, public lg: iBisLanguageService, public iui: iBisUIService,
		public user: iBisEditUserService, public nav: iBisNavigationService, public activatedRoute: ActivatedRoute, public router: Router,
		public file: iBisFileService, public entity: iBisEntityService, public uploadExcel: UploadExcelService) {

		this.entity.onError.subscribe(error => {
			if (error.status === 401) {
				// auth.logout();
				notify('Authorization has expired. Retry to login.', 'error', 3000);
				this.auth.reset();
				this.router.navigateByUrl('/login', { skipLocationChange: true });
			}
		});
	}

	public resetValidation(component: any) {
		if (component) {
			component.reset();
			component.option('isValid', true);
		}
	}

	public enumDisplay(info: any) {
		return info ? info.code + ' - ' + (info.description || '') : '';
	}

	public convertToDate(date: Date): Date {
		return new Date(date.setTime(date.getTime() + (date.getTimezoneOffset() / -60) * 60 * 60 * 1000));
	}

	public get allowEdit(): boolean {
		return this.auth.tabAccess.edit;
	}

	public get allowDelete(): boolean {
		return this.auth.tabAccess.delete;
	}

	public get showActions(): boolean {
		return this.allowEdit || this.allowDelete;
	}

	public get allowedActions(): number {
		return (this.allowEdit ? 1 : 0) + (this.allowDelete ? 1 : 0);
	}

	public get actionsWidth(): number {
		return this.allowedActions * (this.iui.config.ui.actionWidth ?? 35);
	}
}
